import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from '@/components/index/indexPage'
import ProductPage from '@/components/index/productPage'
import DoubleRandom from '@/components/info/doubleRandom'
import FirePrevention from '@/components/info/firePrevention'
import MobileFire from '@/components/info/mobileFire'
import MicroFire from '@/components/info/microFire'
import InternetControl from '@/components/info/internetControl'
import TransportManage from '@/components/info/transportManage'
import SafetyResponsibility from '@/components/info/safetyResponsibility'
import VideoLinkage from '@/components/info/videoLinkage'
import CommunicationManage from '@/components/info/communicationManage'
import PipeEliminator from '@/components/info/pipeEliminator'


Vue.use(Router)

export default new Router({
  routes: [
    { path: "/", redirect: "/indexPage" },
    {
      path: '/indexPage',
      name: 'IndexPage',
      component: IndexPage
    },
    {
      path: '/productPage',
      name: 'ProductPage',
      component: ProductPage
    },
    {
      path: '/doubleRandom',
      name: 'DoubleRandom',
      component: DoubleRandom
    },
    {
      path: '/firePrevention',
      name: 'FirePrevention',
      component: FirePrevention
    },
    {
      path: '/mobileFire',
      name: 'MobileFire',
      component: MobileFire
    },
    {
      path: '/microFire',
      name: 'MicroFire',
      component: MicroFire
    },
    {
      path: '/internetControl',
      name: 'InternetControl',
      component: InternetControl
    },
    {
      path: '/transportManage',
      name: 'TransportManage',
      component: TransportManage
    },
    {
      path: '/safetyResponsibility',
      name: 'SafetyResponsibility',
      component: SafetyResponsibility
    },
    {
      path: '/videoLinkage',
      name: 'VideoLinkage',
      component: VideoLinkage
    },
    {
      path: '/communicationManage',
      name: 'CommunicationManage',
      component: CommunicationManage
    },
    {
      path: '/pipeEliminator',
      name: 'PipeEliminator',
      component: PipeEliminator
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js